<template>
  <v-app>
    <v-app-bar
      app
      color="#002f6c"
      fixed
      dark
      elevate-on-scroll
      height="80"
    >
      <v-container>
        <v-row justify="space-between">
          <v-col class="pa-0">
            <v-row>
              <div class="d-flex">
                <a href="https://www.prosperafrica.gov" target="_blank">
                  <img
                    class="app-logo mr-3"
                    alt="Prosper Africa logo"
                    src="@/assets/img/prosper-africa.svg"
                  />
                </a>
                <v-btn
                  href="/"
                  text
                  class="hide-mobile"
                >
                  <span class="mr-1">Deal Room</span>
                </v-btn>
              </div>

              <v-btn
                href="https://www.prosperafrica.gov/toolkit/"
                target="_blank"
                text
                class="hide-mobile"
              >
                <span class="mr-1">Prosper Africa Resource Library</span>
              </v-btn>

              <v-btn
                v-if="!isLoggedIn"
                to="/sectors/healthcare/investor"
                text
                class="hide-mobile"
              >
                <span class="mr-1">Healthcare sector overview</span>
              </v-btn>
            </v-row>
          </v-col>

          <v-col class="shrink pa-0">
            <user-menu />
          </v-col>
        </v-row>
      </v-container>
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="mobile-icon">
      </v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      fixed
      temporary
      dark
      width="300"
      color="rgb(0, 47, 108)"
      v-model="drawer"
    >
      <app-drawer />
    </v-navigation-drawer>

    <v-main class="pt-0">
      <router-view/>
    </v-main>

    <v-snackbar v-model="modalMessage">
      {{ modalMessage }}
    </v-snackbar>

    <login-modal :shown="modal==='login'" @hide="hideModal" @recover="showRecovery" />
    <recovery-modal :shown="modal==='recover'" @hide="hideModal" @login="login" />

    <app-footer />
    <cookie-alert />
  </v-app>
</template>

<script>
import AppFooter from '@/components/common/app-footer'
import AppDrawer from '@/components/common/app-drawer'
import LoginModal from '@/components/auth/login-modal'
import RecoveryModal from '@/components/auth/recovery-modal'
import UserMenu from '@/components/auth/user-menu'
import CookieAlert from '@/components/common/cookie-alert'

export default {
  name: 'App',
  components: {
    CookieAlert,
    AppDrawer,
    AppFooter,
    UserMenu,
    LoginModal,
    RecoveryModal
  },
  data () {
    return {
      drawer: false,
      group: null
    }
  },
  mounted () {
    this.$store.dispatch('user/checkAndRefresh')
    this.$store.dispatch('user/removeLegacyCookie')
  },
  computed: {
    currentUser () {
      return this.$store.getters['user/currentUser']
    },
    isLoggedIn () {
      return this.$store.getters['user/isLoggedIn']
    },
    modalMessage () {
      return this.$store.getters['modals/modalData']
    },
    modal () {
      return this.$store.getters['modals/currentModal']
    }
  },
  watch: {
    group () {
      this.drawer = false
    }
  },
  methods: {
    showModal (title) {
      this.$store.dispatch('modals/showModal', title)
    },
    hideModal () {
      this.$store.dispatch('modals/hideModal')
    },
    login () {
      this.showModal('login')
    },
    showRecovery () {
      this.showModal('recover')
    }
  }
}
</script>

<style lang="scss">
.v-app-bar--is-scrolled {
  .v-toolbar__content {
    background: #002f6c;
  }
}
.v-toolbar__content {
  align-items: baseline !important;
}
</style>

<style scoped lang="scss">
.v-snack{
  z-index: 100501 !important
}
.app-logo {
  height: 50px;
}
.hide-mobile {
  display: none;
  @media (min-width: 1280px) {
    display: inline-flex;
  }
}
.mobile-icon {
  display: flex;
  @media (min-width: 1280px) {
    display: none;
  }
}
</style>
